export default "__VITE_ASSET__c8fc6317__"